import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { BannerResponse, ContextResponse } from '@woolworthsnz/trader-api';
import {
	AppSettingsService,
	DatalayerService,
	FeatureService,
	MaybeExternalLinkDirective,
	TealiumEventEnum,
} from '@woolworthsnz/styleguide';
import { NgIf } from '@angular/common';
import { TealiumUtagService } from '@woolworthsnz/analytics';

export class BannerItem {
	link: string;
	target: BannerResponse.LinkTargetEnum;
	image: string;
	altText: string;
	name: string;
}

@Component({
	selector: 'dc-banner-item, [dcBannerItem]',
	template: `
		<ng-container *ngIf="bannerItem as banner">
			<a [href]="banner.link" (click)="handleBannerClick()" [target]="getTarget(banner.target)" maybeExternal>
				<img [src]="banner.image" [title]="banner.altText" [alt]="banner.altText" />
			</a>
		</ng-container>
	`,
	styleUrls: ['./banner-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, MaybeExternalLinkDirective],
})
export class BannerItemComponent implements OnInit {
	@Input() bannerItem: BannerItem;
	@Input() index: number;

	@HostBinding('class.withAspectRatio')
	@Input()
	withAspectRatioStyles = true;
	private _isCartologyGA4EventTrackingEnabled = false;
	component: { image: string; altText: string; link: string; target: BannerResponse.LinkTargetEnum };

	constructor(
		private datalayerService: DatalayerService,
		private tealiumUtagService: TealiumUtagService,
		private appSettingsService: AppSettingsService,
		private featureService: FeatureService
	) {}

	ngOnInit(): void {
		this._isCartologyGA4EventTrackingEnabled = this.featureService.isFeatureEnabled(
			ContextResponse.EnabledFeaturesEnum.EnableCartologyGA4EventTracking
		);
	}

	getTarget(target: BannerResponse.LinkTargetEnum): string {
		switch (target) {
			case BannerResponse.LinkTargetEnum.NewWindow:
				return '_blank';
			case BannerResponse.LinkTargetEnum.Content:
			case BannerResponse.LinkTargetEnum.Trolley:
			case BannerResponse.LinkTargetEnum.Self:
			case BannerResponse.LinkTargetEnum.ReplaceAll:
			case BannerResponse.LinkTargetEnum.SelfNoAjax:
			default:
				return '_self';
		}
	}

	handleBannerClick(): void {
		const trackingData = {
			id: this.bannerItem.image,
			altText: this.bannerItem.altText,
			position: `Slot ${this.index + 1}`,
			nameInSiteManagement: this.bannerItem.name,
		};
		this.datalayerService.trackBannerClick({ ...trackingData });
		if (this._isCartologyGA4EventTrackingEnabled) {
			this.onPromoBannerClicked({ ...trackingData });
		}
	}

	onPromoBannerClicked(data: any): void {
		const currentUrl = this.appSettingsService.getSetting('currentUrl');
		const listType = this.datalayerService.getListTypeByUrl(currentUrl);

		this.tealiumUtagService.link({
			event: 'select_promotion',
			tealium_event: TealiumEventEnum.SelectPromotion,
			ecommerce: {
				creative_name: `${listType} Banner`,
				creative_slot: data.position,
				promotion_id: data.altText,
				promotion_name: data.nameInSiteManagement,
			},
		});
	}
}
